import axios from 'axios'

export default class CycleService {
  public getAll() {
    return axios.get('/api/v1/cycles/')
  }
}
